<template>
    <body>
    <h1>Результаты</h1>
    <v-list>
        <v-list-item v-for="result in this.results" :key="result.text">
            <v-list-item-title>{{result.text}}</v-list-item-title>
        </v-list-item>
    </v-list>
    </body>
</template>

<script>

    import firebase from "firebase";
    import parser from '../converter'


    export default {
        data() {
            return {
                results: null
            }
        },
        mounted() {
            firebase
                .app()
                .storage('gs://nhl-manager.appspot.com')
                .ref().child('Results.xlsx').getDownloadURL().then(url => {

                var xhr = new XMLHttpRequest();
                xhr.responseType = 'blob';
                xhr.onload = (ev =>  {
                    xhr.response.arrayBuffer().then(buffer => {
                         let a =  parser({
                            source: buffer,
                            sheets: 0,
                            columnToKey: {
                                A: 'text',
                            }
                        }).Results;
                        this.results = a

                    })
                });
                xhr.open('GET', url);
                xhr.send();
            })
        }
    }
</script>


